import type { ReactNode } from 'react';

interface TopBarProps {
  title: ReactNode;
  /** Пояснение серым после заголовка (на узком окне сокращается многоточием). */
  hint?: ReactNode;
  /** Кнопки справа. */
  actions?: ReactNode;
  /** Разделы ассистента — серый фон и компактнее (как в макете). */
  section?: boolean;
  children?: ReactNode;
}

/** Верхняя строка страницы — закреплена при прокрутке (макет: 56 px). */
export function TopBar({ title, hint, actions, section, children }: TopBarProps) {
  return (
    <header className={section ? 'v2-topbar is-section' : 'v2-topbar'}>
      <h1>{title}</h1>
      {hint && <span className="v2-topbar-hint">{hint}</span>}
      {children}
      {actions && <div className="v2-topbar-actions">{actions}</div>}
    </header>
  );
}
